module.exports = __webpack_public_path__ + "static/img/15d.1adf294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/15d.jpg
// module id = b7hD
// module chunks = 0